import { create } from 'zustand'
import { User, CreateUserDto, UpdateUserDto } from '@/types'
import { usersService } from '@/services/users.service'

interface WholesalersState {
  wholesalers: User[] | null
  isInitialized: boolean
  fetchWholesalers: (force?: boolean) => Promise<void>
  addWholesaler: (user: CreateUserDto) => Promise<User>
  updateWholesaler: (id: string, user: UpdateUserDto) => Promise<User>
  deleteWholesaler: (id: string) => Promise<void>
}

export const useWholesalersStore = create<WholesalersState>((set, get) => ({
  wholesalers: null,
  isInitialized: false,

  fetchWholesalers: async (force = false) => {
    if (get().isInitialized && !force) return
    const data = await usersService.getWholesalers()
    set({ wholesalers: data, isInitialized: true })
  },

  addWholesaler: async (userData: CreateUserDto) => {
    const newUser = await usersService.create(userData)
    set(state => ({
      wholesalers: [...(state.wholesalers || []), { ...newUser, attachedResellersCount: 0 }],
    }))
    return newUser
  },

  updateWholesaler: async (id: string, userData: UpdateUserDto) => {
    const updatedUser = await usersService.update(id, userData)
    set(state => ({
      wholesalers: state.wholesalers?.map(u => (u._id === id ? updatedUser : u)),
    }))
    return updatedUser
  },

  deleteWholesaler: async (id: string) => {
    await usersService.delete(id)
    set(state => ({
      wholesalers: state.wholesalers?.filter(u => u._id !== id),
    }))
  },
}))
